import ChatMainWrapper from "components/ChatPanelWrapper/ChatWrapper";
import { memo } from "react";

const AdminChat = () => {

    return(
        <ChatMainWrapper/>
    )
}
export default memo(AdminChat);